import React, { useContext } from "react";
import { medicalPoliciesPaymentAndCodingPolicies } from "../../../constants/urls";
import { StateContext } from "../../../context/stateContext";
import { useFetch } from "../../../hooks/useFetch";
import { IURLAssetReference } from "../../../interfaces/urlAssetReference";
import { translations } from "../../../translate";
import utils from "../../../utils/helperFunction";
import ParentFragmentHTML from "../../lib/ParentFragmentHTML";
import LegalAndPrivacyContainer from "../legalAndPrivacyContainer/LegalAndPrivacyContainer";

const MedicalPoliciesAndPayment = () => {
  const { cidmUrl, stateUSACode, languageCode } = useContext(StateContext);
  const { getStateName } = utils;
  const state = getStateName(stateUSACode);
  const URL = `${cidmUrl}${medicalPoliciesPaymentAndCodingPolicies(state, languageCode)}`;
  const { data, loading } = useFetch<{ urlAssetReferences: IURLAssetReference[] }>(URL);
  return (
    <LegalAndPrivacyContainer title={translations.medPolices[languageCode]}>
      {!loading && <ParentFragmentHTML data={data?.urlAssetReferences} />}
    </LegalAndPrivacyContainer>
  );
};

export default MedicalPoliciesAndPayment;
